import styled from 'styled-components'


export const Wrapper = styled.section`
  position: relative;
  padding: 2rem;
  background-color: var(--white);

  @media (max-width: 768px) {
    padding: 1rem;
  }

  @media (max-width: 480px) {
    padding: 0.75rem;
  }

  .overlay {
    position: fixed;
    top: 0; left: 0;
    width: 100vw; height: 100vh;
    background: rgba(0, 0, 0, 0.2);
    z-index: 999;
  }

  .age-group-filter {
    display: flex;
    gap: 2rem;
    margin-bottom: 1rem;
    label {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      cursor: pointer;
      input { margin-right: 0.25rem; }
    }
  }

  .search-bar {
    display: flex;
    height: 40px;
    margin-bottom: 1rem;

    input {
      flex-grow: 1;
      padding: 0 0.75rem;
      border: 1px solid var(--grey-300);
      border-right: none;
      border-radius: 4px 0 0 4px;
      height: 100%;
      box-sizing: border-box;
    }

    .clear,
    .search {
      width: 40px;
      border: 1px solid var(--grey-300);
      background: white;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      height: 100%;
      box-sizing: border-box;
    }

    .clear {
      border-left: none;
      border-right: none;
    }
    .search {
      border-left: none;
      border-radius: 0 4px 4px 0;
    }

    @media (max-width: 360px) {
      height: 36px;

      input {
        font-size: 0.85rem;
      }

      .clear,
      .search {
        width: 36px;
      }
    }
  }

  .sort-button-wrapper {
    position: relative;
    margin-bottom: 1rem;
    button {
      padding: 0.5rem 1rem;
      background: var(--grey-100);
      border: 1px solid var(--grey-400);
      cursor: pointer;
    }

    @media (max-width: 360px) {
      button {
        font-size: 0.82rem;
        padding: 0.4rem 0.7rem;
      }
    }
  }

  .sort-popup {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    background: white;
    border: 1px solid var(--grey-400);
    box-shadow: var(--shadow-2);
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    z-index: 1000;
    .sort-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.5rem;
    }
    .close {
      background: none;
      border: none;
      cursor: pointer;
    }

    @media (max-width: 480px) {
      width: min(90vw, 280px);
    }
  }

  .book-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 1rem;
    margin-top: 1rem;

    .book-card {
      background: white;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 6px rgba(0,0,0,0.1);
      transition: box-shadow 0.2s ease;
      display: flex;
      flex-direction: column;
      cursor: pointer;
      transition: transform 0.2s ease, box-shadow 0.2s ease;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      }

      .cover {
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--primary-100);
        margin-bottom: 0.5rem;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .meta {
        padding: 0 1rem 1rem;
        flex-grow: 1;
        p { margin: 0.25rem 0; }
      }
    }
  }

  @media (max-width: 480px) {
    .book-grid {
      grid-template-columns: 1fr;
    }
  }

  .book-desc-label {
    font-weight: bold;
    margin-right: 0.25rem;
  }

  @media (max-width: 360px) {
    .book-grid .book-card .cover {
      height: 132px;
    }

    .book-grid .book-card .meta {
      padding: 0 0.75rem 0.75rem;
      font-size: 0.84rem;
    }
  }

  .pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.6rem;
    margin-top: 1rem;
    select { margin-left: 0.5rem; }
    button { margin-left: 1rem; }

    @media (max-width: 480px) {
      justify-content: flex-start;
      font-size: 0.86rem;

      button {
        margin-left: 0;
      }
    }

    @media (max-width: 360px) {
      gap: 0.45rem;

      label {
        display: flex;
        align-items: center;
        gap: 0.35rem;
      }

      select {
        margin-left: 0;
        max-width: 86px;
      }

      button {
        font-size: 0.78rem;
        padding: 0.35rem 0.55rem;
      }
    }
  }
`;